import { Component, OnInit, ViewChild } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Getunitdetails, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Router, Route, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document,$;

@Component({
  selector: 'app-view-revisions',
  templateUrl: './view-revisions.component.html',
  styleUrls: ['./view-revisions.component.css']
})
export class ViewRevisionsComponent implements OnInit {
    @ViewChild('Writer_Pond_Attach') Writer_Pond_Attach: any
    @ViewChild('Writer_Pond_Plag') Writer_Pond_Plag: any

      public despositionArray   : any = AppSettings.disposition;
      public documentTypeArray  : any = AppSettings.documentType;
      public orderStatus        : any = AppSettings.orderStatus;
      public loading            : any = false;
      public loadingWriters     : any = false;

      public DOC_URL                  : any = AppSettings.DOC_URL
      public docs_revised_orders_path : any = AppSettings.docs_revised_orders_path

      public Rev_SubWork        : any = { document_note: '', attach: [], oldAttach: '', plag_report: [], oldPlag: '' };
      public Rev_InvalidRes     : any = '';
      public Rev_Index          : any = null;
      public Rev_ActionLoader   : any = false;
      public Rev_FileLoader     : any = false;

      public Rev_Note           : any = '';

      public paginatePage       : any;
      public leads              : any = [];
      public comments           : any = [];
      public agentComments      : any = [];
      public qaComments         : any = [];
      public agentsSub          : any;
      public browserSub         : any;
      public agents             : any;
      public writers            : any;
      public qa                 : any;
      public loader             : any;

      @ViewChild(DataTableDirective)
      public dtElement               : DataTableDirective;
      public dtOptions               : DataTables.Settings = {};
      public dtTrigger               : any = new Subject();

      public searchParams            : any = { order_id : '', date_from: '', date_to:'', writer_id: null  };
      public fullRangeDate           : any;
      public selectedDesposition     : any;
      public routeSaver              : any;
      public activeUser              : any;

      public WR_Attach_PondOptions = {
          allowMultiple: true,
          labelIdle: `<p class='pond-badge'>Drag & Drop or <span class="browse">browse</span> <span> Upload as .zip or .rar format in case of multiple files. </span></p>`,
          allowImagePreview: true,
          maxFileSize: '5MB',
          imagePreviewMaxFileSize: '5MB',
          // stylePanelLayout: 'compact circle',
          server: {
              url: AppSettings.API_ENDPOINT,
              timeout: 200000,
              process: {
                  url: './admin/upload-temp-files',
                  method: 'POST',
                  withCredentials: false,
                  timeout: 30000,
                  onload: (response) => {
                    // Hide File Upload Loader
                    this.Rev_FileLoader = false;

                    let parsedData = JSON.parse(response);
                    let decrptedImg = this.helperService.decrypted(parsedData.data);
                    let image = JSON.parse(decrptedImg);

                    // Add image to pro image array
                    this.Rev_SubWork.attach.push(image.id);

                    return image.id;
                  },
                  onerror: (response) => {
                      return response.key;
                  },
                  ondata: (formData) => {
                      // Show File Upload Loader
                      this.Rev_FileLoader = true;

                      return formData;
                  }
              },
              revert: (uniqueFileId, load, error) => {
                  // Rmeove from array
                  this.Rev_SubWork.attach.splice(this.Rev_SubWork.attach.indexOf(uniqueFileId), 1);

                  // Clear Image
                  load();
              },
              restore : null,
              load    : null,
              fetch   : null
          }
      };

      public WR_Plag_PondOptions = {
          allowMultiple: true,
          labelIdle: `<p class='pond-badge'>Drag & Drop or <span class="browse">browse</span> <span> Upload as .zip or .rar format in case of multiple files. </span></p>`,
          allowImagePreview: true,
          maxFileSize: '5MB',
          imagePreviewMaxFileSize: '5MB',
          // stylePanelLayout: 'compact circle',
          server: {
              url: AppSettings.API_ENDPOINT,
              timeout: 200000,
              process: {
                  url: './admin/upload-temp-files',
                  method: 'POST',
                  withCredentials: false,
                  timeout: 30000,
                  onload: (response) => {
                    // Hide File Upload Loader
                    this.Rev_FileLoader = false;

                    let parsedData = JSON.parse(response);
                    // console.log("response.data******", response.data);
                    let decrptedImg = this.helperService.decrypted(parsedData.data);
                    let image = JSON.parse(decrptedImg);

                    // Add image to pro image array
                    this.Rev_SubWork.plag_report.push(image.id);

                    return image.id;
                  },
                  onerror: (response) => {
                      return response.key;
                  },
                  ondata: (formData) => {
                      // Show File Upload Loader
                      this.Rev_FileLoader = true;

                      return formData;
                  }
              },
              revert: (uniqueFileId, load, error) => {
                  // Rmeove from array
                  this.Rev_SubWork.plag_report.splice(this.Rev_SubWork.plag_report.indexOf(uniqueFileId), 1);

                  // Clear Image
                  load();
              },
              restore : null,
              load    : null,
              fetch   : null
          }
      };

      pondFiles = []

      constructor(
        private helperService       : HelperService,
        private activatedRoute      : ActivatedRoute,
        private router              : Router,
        private agentsService       : Agents,
        private authenticationService : AuthenticationService,
      ) {

        this.browserSub = this.authenticationService.isBrowser.subscribe(isBrowser => {
          if (isBrowser) {
            // Get Agents
            this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
              if (agents) {
                this.agents = agents.agents;
                this.qa     = agents.qa;
              }
            });

            this.routeSaver = this.router.url;

            this.activeUser = this.authenticationService.get_currentUserValue();

              this.dtOptions = {
                paging: true,
                info: true,
                // ordering: false,
                pagingType: 'full_numbers',
                pageLength: 25,
                serverSide: true,
                processing: true,
                searching: false,
                'language': AppSettings.dataTableLang,
                "columnDefs": [
                  { "orderable": false,                                                                    "targets": 0 },
                  { "orderable": false,                                                                    "targets": 1 },
                  { "orderable": false, visible: this.activeUser.is_writermanager,                         "targets": 2 },
                  { "orderable": false, visible: this.activeUser.is_writermanager,                         "targets": 3 },
                  { "orderable": false, visible: this.activeUser.is_writermanager,                         "targets": 4 },
                  { "orderable": false,                                                                    "targets": 5 },
                  { "orderable": false,                                                                    "targets": 6 },
                  { "orderable": false, visible: this.activeUser.is_writer,                                "targets": 7 },
                  { "orderable": false, visible: this.activeUser.is_writer,                                "targets": 8 },
                  { "orderable": false, visible: this.activeUser.is_writer,                                "targets": 9 },
                  { "orderable": false, visible: this.activeUser.is_writer,                                "targets": 10 },
                  { "orderable": false, visible: this.activeUser.is_writer,                                "targets": 11 },
                ],
                "order": [[ 0, "desc" ]],
                ajax: (dataTablesParameters: any, callback) => {
                  // Show Loader
                  this.loading = true;
                  // console.log("dataTablesParameters", dataTablesParameters);

                  let url = '';
                  if(this.activeUser.is_writer)
                    url  = AppSettings.API_ENDPOINT + 'writers/revisions';
                  else if(this.activeUser.is_writermanager)
                    url  = AppSettings.API_ENDPOINT + 'writers/get-revisions-for-manager';

                  let dtParams = {
                                  order_id          : this.searchParams.order_id,
                                  writer_id         : this.searchParams.writer_id,
                                  date_from         : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
                                  date_to           : this.searchParams.date_to   ? this.helperService.caonvertDateToString(this.searchParams.date_to, false)   : '',
                                  start             : dataTablesParameters.start,
                                  length            : dataTablesParameters.length,
                                  order             : dataTablesParameters.order,
                                  columns           : dataTablesParameters.columns
                                };

                  // For Record Serial Numbers
                  this.paginatePage = dataTablesParameters.start;
                  this.leads.data = [];

                  this.helperService.httpPostRequestsDecryp(url, dtParams)
                    .then( resp => {
                        this.leads        = JSON.parse(resp);


                        console.log("this.leads", this.leads);

                        // Set Default page len
                        this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                        // Hide Loader
                        this.loading = false;

                        callback({
                          recordsTotal: this.leads.total,
                          recordsFiltered: this.leads.total,
                          // recordsFiltered: resp['recordsFiltered'],
                          // recordsFiltered: 1000,
                          data: []
                        });

                        // // $(".paginate_button .current").css("color", "white");
                        // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                        $('div.dataTables_length select').addClass('dt-form-control');
                        $('div.dataTables_filter input').addClass('dt-form-control');
                    })
                    .catch(error => {
                        // Set loader false
                        this.loading = false;

                        // // Rerender DT in case of failure
                        // this.rerender();

                        console.log("error: ",error);
                    });
                },
                columns: [
                  // { data: 'multiDelete' },
                  { data: 'id' },
                  { data: 'orderId' },
                  { data: 'revisionNotes' },
                  { data: 'attachments' },
                  { data: 'revisionMarkedOn' },
                  { data: 'remainingTime' },
                  { data: 'status' },
                  { data: 'submit' },
                  { data: 'markInvalid' },
                  // for writerManager
                  { data: 'timestamp' },
                  { data: 'clientName' },
                  { data: 'writer' },
                ],
                // Use this attribute to enable the responsive extension
                responsive: false
              }
          }
        });
      }



      ngOnInit() {

      }

      ngAfterViewInit() {
        if(this.activeUser.is_writermanager) {
            // Get writers first by Team
            this.getManagerTeam().then((resp) => {
              this.dtTrigger.next();
            });
        } else {
            this.dtTrigger.next();
        }
      }

      ngOnDestroy(): void {
        // Do not forget to unsubscribe the event
        this.dtTrigger.unsubscribe();
        if (typeof this.agentsSub != 'undefined') {
          //prevent memory leak when component destroyed
          this.browserSub.unsubscribe();
          this.agentsSub.unsubscribe();
        }
      }

      rerender(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

          // Destroy the table first
          dtInstance.destroy();

          // Call the dtTrigger to rerender again
          this.dtTrigger.next();
        });
      }

      splitFromTo(){
        if(this.fullRangeDate){
          this.searchParams.date_from = this.fullRangeDate[0];
          this.searchParams.date_to =   this.fullRangeDate[1];
        }

        this.rerender();
      }

      agentSearch(id, agentArr) {
        for (var i = 0; i < agentArr.length; i++) {
          if (agentArr[i].id === id) {
            return agentArr[i].name;
          }
        }
      }

      clearFilters(){
        this.fullRangeDate = '';
        this.searchParams  = { order_id : '', date_from: '', date_to:'', writer_id: null };
        this.rerender();
      }

      getManagerTeam(): Promise<any> {
        let self = this;
        return new Promise((resolve, reject) => {
          // Show Loader
          self.loadingWriters = true;

          let url  = AppSettings.API_ENDPOINT + "writers/get-manager-team";

          self.helperService.httpPostRequestsDecryp(url, {}).then(resp => {
              this.writers         = JSON.parse(resp).writerTeamArray;
              resolve(resp);

              // Hide loader
              self.loadingWriters = false;
          }).catch(err => {
              // Hide loader
              self.loadingWriters = false;

              resolve(err);
          });
        });
      }

      download_Revisions_Attach(lead, index) {
        // Show Zip loader
        this.leads.data[index].creatingZip = true;

        let url  = AppSettings.API_ENDPOINT + "shared/create-revs-zip";
        let data = { id: this.leads.data[index].revisionId };

        this.helperService.httpPostRequests(url,data).then(resp => {
            if(typeof resp != "undefined" && resp.status == 'OK') {
                window.open(resp.zip, '_blank');
            } else {
                Swal.fire('', resp.message , 'error');
            }

            // Hide Zip loader
            this.leads.data[index].creatingZip = false;
        }).catch(err => {
            // Hide Zip loader
            this.leads.data[index].creatingZip = false;
        });
      }

      openRevNoteModal(lead) {
        this.Rev_Note = lead.revision_notes;

        // Open Modal
        ($('#revisionNotes') as any).modal('show');
      }

      openRevSubmitWorkModal(index) {
        this.Rev_SubWork = {
                              isUpdate      : this.leads.data[index].is_viewed == 1 ? true : false,
                              document_note : '',
                              attach        : [],
                              oldAttach     : '',
                              plag_report   : [],
                              oldPlag       : '',
                              revWorkID     : null
                          };
        this.Rev_Index = index;

        // Show Loader
        this.leads.data[this.Rev_Index].loadingWork = true;

        let url  = AppSettings.API_ENDPOINT + "writers/rev-details";
        let data = { order_id: this.leads.data[this.Rev_Index].oid };

        this.helperService.httpPostRequests(url,data).then(resp => {
            // Set Previous data if any
            if(typeof resp != "undefined" && resp.status == 'OK') {
              this.Rev_SubWork.isUpdate      = true;
              this.Rev_SubWork.document_note = resp.result.document_note;
              this.Rev_SubWork.oldAttach     = resp.result.attach.split("~");
              this.Rev_SubWork.oldPlag       = resp.result.plag_report.split("~");
              this.Rev_SubWork.revWorkID     = resp.result.id;
            }
            console.log("this.Rev_SubWork: ", this.Rev_SubWork);

            // Remove all files
            this.Writer_Pond_Attach.removeFiles();
            this.Writer_Pond_Plag.removeFiles();

            // Open Modal
            ($('#submitWork') as any).modal('show');

            // Hide Zip loader
            this.leads.data[this.Rev_Index].loadingWork = false;
        }).catch(err => {
            // Hide Zip loader
              this.leads.data[this.Rev_Index].loadingWork = false;
        });
      }

      submitRevWork() {
        if(this.Rev_SubWork.document_note == '' || this.Rev_SubWork.attach.length == 0 || this.Rev_SubWork.plag_report == 0) {
          Swal.fire('', "Document Note and Attachments are required", 'error');
          return;
        }
        // Show Loader
        this.Rev_ActionLoader = true;

        let url  = AppSettings.API_ENDPOINT + "writers/submit-rev-work";
        let data = {
                      isUpdate      : this.Rev_SubWork.isUpdate,
                      oid           : this.leads.data[this.Rev_Index].oid,
                      revWorkID     : this.Rev_SubWork.revWorkID ? this.Rev_SubWork.revWorkID : null,
                      revision_id   : this.leads.data[this.Rev_Index].revisionId,
                      document_note : this.Rev_SubWork.document_note,
                      attach        : this.Rev_SubWork.attach,
                      plag_report   : this.Rev_SubWork.plag_report,
                   }

        this.helperService.httpPostRequests(url, data).then(resp => {
            // Hide Modal
            ($('#submitWork') as any).modal('hide');

            if(typeof resp != "undefined" && resp.status == 'OK') {
                // Rerender to get changes
                this.rerender();

                Swal.fire('', resp.message , 'success');
            } else {
                Swal.fire('', resp.message , 'error');
            }

            // Hide Zip loader
            this.Rev_ActionLoader = false;
        }).catch(err => {
            // Hide Zip loader
            this.Rev_ActionLoader = false;
        });
      }

      openMarkInvalidModal(index) {
        this.Rev_InvalidRes = '';
        this.Rev_Index      = index;

        // Open Modal
        ($('#markInvalid') as any).modal('show');
      }

      submitInvalidRes() {
        if(!this.Rev_InvalidRes) {
          Swal.fire('', "Reason is required", 'error');
          return;
        }

        // Show Loader
        this.Rev_ActionLoader = true;

        let url  = AppSettings.API_ENDPOINT + "writers/mark-rev-invalid";
        let data = {
                      revision_id          : this.leads.data[this.Rev_Index].revisionId,
                      invalid_request_note : this.Rev_InvalidRes
                   }

        this.helperService.httpPostRequests(url, data).then(resp => {
            // Hide Modal
            ($('#markInvalid') as any).modal('hide');

            if(typeof resp != "undefined" && resp.status == 'OK') {
                // Rerender to get changes
                this.rerender();

                Swal.fire('', resp.message , 'success');
            } else {
                Swal.fire('', resp.message , 'error');
            }

            // Hide Zip loader
            this.Rev_ActionLoader = false;
        }).catch(err => {
            // Hide Zip loader
              this.Rev_ActionLoader = false;
        });
      }

      pondHandleInit() {
        console.log('FilePond has initialised', this.Writer_Pond_Plag);
      }

      pondHandleAddFile(event: any) {
        console.log('A file was added', event);
      }

      pondHandleActivateFile(event: any) {
        console.log('A file was activated', event)
      }

      showOrderStatus(id, statusArr) {
        for (var i = 0; i < statusArr.length; i++) {
          if (statusArr[i].value === id) {
            return statusArr[i].name;
          }
        }
      }

      showStatusColor(id, statusArr) {
        for (var i = 0; i < statusArr.length; i++) {
          if (statusArr[i].value === id) {
            return statusArr[i].color;
          }
        }
      }

}
